"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleParagraphPropertiesDestination = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../base-utils/map-creator");
var string_1 = require("@devexpress/utils/lib/utils/map/string");
var paragraph_numbering_reference_destination_1 = require("../../paragraph-properties/paragraph-numbering-reference-destination");
var paragraph_properties_base_destination_1 = require("../../paragraph-properties/paragraph-properties-base-destination");
var StyleParagraphPropertiesDestination = (function (_super) {
    tslib_1.__extends(StyleParagraphPropertiesDestination, _super);
    function StyleParagraphPropertiesDestination(data, styleDestination, paragraphProperties, tabs) {
        var _this = _super.call(this, data, paragraphProperties, tabs) || this;
        _this.styleDestination = styleDestination;
        return _this;
    }
    Object.defineProperty(StyleParagraphPropertiesDestination.prototype, "elementHandlerTable", {
        get: function () {
            return StyleParagraphPropertiesDestination.handlerTable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StyleParagraphPropertiesDestination.prototype, "numberingId", {
        get: function () {
            return this.styleDestination.numberingId;
        },
        set: function (value) {
            this.styleDestination.numberingId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StyleParagraphPropertiesDestination.prototype, "listLevelIndex", {
        get: function () {
            return this.styleDestination.listLevelIndex;
        },
        set: function (value) {
            this.styleDestination.listLevelIndex = value;
        },
        enumerable: false,
        configurable: true
    });
    StyleParagraphPropertiesDestination.getThis = function (data) {
        return data.destinationStack.getThis();
    };
    StyleParagraphPropertiesDestination.handlerTable = new map_creator_1.MapCreator(string_1.StringMapUtils.map(paragraph_properties_base_destination_1.ParagraphPropertiesBaseDestination.handlerTable, function (e) { return e; }))
        .add('numPr', function (data) { return new paragraph_numbering_reference_destination_1.ParagraphNumberingReferenceDestination(data, StyleParagraphPropertiesDestination.getThis(data)); })
        .get();
    return StyleParagraphPropertiesDestination;
}(paragraph_properties_base_destination_1.ParagraphPropertiesBaseDestination));
exports.StyleParagraphPropertiesDestination = StyleParagraphPropertiesDestination;
